import { gql } from '@apollo/client';

export const CART_FIELDS = gql`
  fragment allCartFields on Cart {
    uuid
    recipientName
    funnelData
    metroId
    orderOn
    userId
    tenantEligibilityConfigLogicalId
    deliveryDates
    modifiedDuringFunnel
    createdFromPersonalizedPlan
    status
    cartDeliveries {
      id
      createdAt
      updatedAt
      status
      deliveryType
      estimatedTransitTime
      estimatedDeliveryDate
      deliveryDate
      lineItems {
        id
        createdAt
        updatedAt
        variantId
        variant
        price
        quantity
      }
    }
    cartLedger {
      subtotal
      discountTotal
      creditTotal
      deliveryTotal
      tax
      grandTotal
      precreditTotal
    }
    discount {
      amount
      code
      type
    }
  }
`;

export const CART_FIELDS_WITH_PREVIEW_DISCOUNT = gql`
  fragment allCartFieldsWithPreviewDiscount on Cart {
    uuid
    recipientName
    funnelData
    metroId
    orderOn
    userId
    tenantEligibilityConfigLogicalId
    deliveryDates
    modifiedDuringFunnel
    createdFromPersonalizedPlan
    status
    cartDeliveries {
      id
      createdAt
      updatedAt
      status
      deliveryType
      estimatedTransitTime
      estimatedDeliveryDate
      deliveryDate
      lineItems {
        id
        createdAt
        updatedAt
        variantId
        variant
        price
        quantity
      }
    }
    cartLedger(previewFunnelDiscountCode: $previewFunnelDiscountCode) {
      subtotal
      discountTotal
      creditTotal
      deliveryTotal
      tax
      grandTotal
      precreditTotal
    }
    discount {
      amount
      code
      type
    }
  }
`;
